import { IconButton, type IconButtonProps, Menu } from '@mui/material';
import { Settings } from '@tempo-io/sui-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

type SettingsProps = IconButtonProps & {
  children: React.ReactNode;
  icon?: React.ReactNode;
};

export const SettingsMenu = (props: SettingsProps) => {
  const { icon, children, ...iconProps } = props;
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label={t(($) => $.intake.a11y.settingsMenu)}
        {...iconProps}
        onClick={handleClick}
      >
        {icon ? icon : <Settings className="size-6" />}
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {children}
      </Menu>
    </>
  );
};
